import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('notebooks');
const type = createActionType('notebooks');

export const OPEN_NOTEBOOK = type('OpenNotebook');
export const GET_STARTERS = apiType('GetStarters');
export const START_CONVERSATION = type('StartConversation');
export const SEND_MESSAGE = apiType('SendMessage');
export const DELETE_MESSAGE = type('DeleteMessage');
export const SELECT_CONVERSATION = type('SelectConversation');
export const NEW_CONVERSATION = type('NewConversation');
export const EXECUTE_SQL = apiType('ExecuteSql');
export const DELETE_CONVERSATION = type('DeleteConversation');
export const GET_CONFIG = apiType('GetConfig');
export const SET_CONFIG = apiType('SetConfig');
export const SAVE_QUERY = type('SaveQuery');
export const CREATE_SQL_VIEW = apiType('CreateSqlView');
export const DOCUMENT_NODE = apiType('DocumentNode');
export const DESCRIBE_NODE_SQL = apiType('DescribeNodeSql');
export const UPDATE_SQL = type('UpdateSql');
